export default {
  page_header: {
    home_button_click: "page_header:home_button_click",
    spotlight_search_button_click: "page_header:spotlight_search_button_click",
    team_switcher_button_click: "page_header:team_switcher_button_click"
  },
  app_menu: {
    home_menu_item_click: "app_menu:home_menu_item_click",
    search_menu_item_click: "app_menu:search_menu_item_click",
    experiments_menu_item_click: "app_menu:experiments_menu_item_click",
    datasets_menu_item_click: "app_menu:datasets_menu_item_click",
    configure_new_experiment_menu_item_click: "app_menu:configure_new_experiment_menu_item_click",
    upload_dataset_menu_item_click: "app_menu:upload_dataset_menu_item_click",
    profile_menu_item_click: "app_menu:profile_menu_item_click",
    organization_menu_item_click: "app_menu:organization_menu_item_click",
    settings_menu_item_click: "app_menu:settings_menu_item_click",
    atinary_menu_item_click: "app_menu:atinary_menu_item_click"
  },
  spotlight_search: {
    toggle_by_hotkey: "spotlight_search:toggle_by_hotkey",
    home_click: "spotlight_search:home_click",
    new_experiment_click: "spotlight_search:new_experiment_click",
    upload_dataset_click: "spotlight_search:upload_dataset_click",
    favorite_experiment_click: "spotlight_search:favorite_experiment_click",
    recent_experiment_click: "spotlight_search:recent_experiment_click",
    other_experiment_click: "spotlight_search:other_experiment_click"
  },
  team_switcher: {
    team_click: "team_switcher:team_click"
  },
  dashboard: {
    team_activity_experiment_click: "dashboard:team_activity_experiment_click",
    team_activity_dataset_click: "dashboard:team_activity_dataset_click",
    configure_new_experiment_button_click: "dashboard:configure_new_experiment_button_click",
    upload_dataset_click: "dashboard:upload_dataset_click"
  },
  favorite_experiment_list: {
    experiment_click: "favorite_experiment_list:experiment_click"
  },
  recent_experiments_list: {
    experiment_click: "recent_experiments_list:experiment_click"
  },
  dataset_drop_zone: {
    file_upload: "dataset_drop_zone:file_upload"
  },
  upload_dataset_modal: {
    dataset_create: "upload_dataset_modal:dataset_create_button_click"
  },
  experiment_measurements: {
    recommendations_download: "experiment_measurements:recommendations_download_button_click",
    results_upload: "experiment_measurements:results_upload_button_click",
    submit_results: "experiment_measurements:submit_results_button_click"
  },
  predictions: {
    query: "predictions:query_button_click",
    explanation_chart_query: "predictions:query_explanation_chart_button_click"
  },
  experiment_details: {
    use_as_template: "experiment_details:use_as_template_button_click"
  },
  experiment_favorite_button: {
    click: "experiment_favorite_button:click"
  },
  experiment_list: {
    use_as_template: "experiment_list:use_as_template_button_click",
    create_experiment_button_click: "experiment_list:create_experiment_button_click",
    experiment_click: "experiment_list:experiment_click",
    filter_change: "experiment_list:filter_change"
  },
  dataset_list: {
    use_as_input_dataset: "dataset_list:use_as_input_dataset_button_click",
    dataset_click: "dataset_list:dataset_click",
    generated_by_experiment_click: "dataset_list:generated_by_experiment_click",
    used_by_experiment_click: "dataset_list:used_by_experiment_click"
  },
  experiment_draft: {
    experiment_create: "experiment_draft:experiment_create_button_click"
  },
  historical_data_mapping: {
    save_blocked_output_dataset_constant: "historical_data_mapping:save_blocked_output_dataset_constant"
  },
  landscape_chart: {
    expand: "landscape_chart:expand"
  },
  settings: {
    theme_change: "settings:theme_change",
    clear_local_storage_button_click: "settings:clear_local_storage_button_click"
  }
};
